module.exports = __webpack_public_path__ + "img/stock0.c721b2cf.png";